import { SuperDrawerContent, SuperDrawerHeader } from "@homebound/beam";
import { CommentFeed } from "src/components/comments/CommentFeed";
import { useGetCommentsQuery } from "src/components/comments/CommentsSuperDrawer.generated";
import { queryResult } from "src/utils";

type CommentsSuperDrawerProps = {
  commentableId: string;
};

export function CommentsSuperDrawer(props: CommentsSuperDrawerProps) {
  const { commentableId } = props;
  const query = useGetCommentsQuery({ variables: { commentableId } });

  return (
    <SuperDrawerContent>
      {queryResult(query, ({ commentable }) => (
        <>
          <SuperDrawerHeader title={commentable.name ?? commentable.id} hideControls />
          <CommentFeed commentable={commentable} />
        </>
      ))}
    </SuperDrawerContent>
  );
}
